import { AutocompleteOptionType, TAutocompleteOption } from '@spotnana/blocks/src/Autocomplete/Autocomplete.types';
import { countryList } from 'obt-common';

type TCountryListOption = (typeof countryList)[number];
export type TCountryOption = TAutocompleteOption<{}>;

function findRelevantOptions(options: TCountryListOption[], searchText: string): TCountryListOption[] {
  if (searchText.length === 0) {
    return options;
  }
  return options.filter((option) => option.label.toLowerCase().includes(searchText.toLowerCase()));
}

const allCountryOptions = countryList.map((option) => ({
  ...option,
  type: AutocompleteOptionType.STANDALONE,
}));

/**
 * This function returns relevant search airlines
 */
export function getRelevantSearchCountries(
  searchText: string,
  availableCountryList: TCountryListOption[],
): TCountryOption[] {
  const countryOptions: TCountryListOption[] = findRelevantOptions(availableCountryList, searchText);

  return countryOptions.slice(0, 10).map((option) => ({
    ...option,
    type: AutocompleteOptionType.STANDALONE,
  }));
}

export function getCurrentCountryOption(value: string) {
  return allCountryOptions.find((option) => option.value === value);
}
